module.exports = __webpack_public_path__ + "static/media/bullseye-arrow.0ff5b996.svg";